import { CreateCommentInput } from "@/generated/generated-hooks";

import { GetCreateCommentInputArgs } from "../type";

export const getCreateCommentInput = (
  args: GetCreateCommentInputArgs,
): CreateCommentInput => {
  const { postId, parentCommentId } = args;

  return {
    postId,
    parentCommentId,
    content: "",
    mentionUserIds: [],
  };
};
